'use client';

import { useEffect } from 'react';
import { ConTextAtom } from '@gandalf/babylon/atoms/text';
import { Section } from '@frodo/ui/tokens/section/Section';
import { clientLoggerService } from '@frodo/lib/services/logger/clientLogger.service';
import { globalErrorTrans } from '@frodo/lib/utils/common/globalErrorTrans';
import { extractCountryCode } from '@frodo/lib/utils/common/helper';
import cls from './ErrorWrapper.module.scss';

export type ErrorWrapperProps = {
  error: Error & { digest?: string };
};

export const ErrorWrapper = ({ error }: ErrorWrapperProps) => {
  const countryCode = extractCountryCode(window.location.host);
  const countryTrans = globalErrorTrans[countryCode];

  useEffect(() => {
    clientLoggerService.error(error);
  }, [error]);

  return (
    <div>
      <Section clsName={cls.section}>
        <div className={cls.container}>
          <ConTextAtom
            align="center"
            fontFamily="main"
            fontSizes="extra"
            tag="h2"
            cls={cls.message}
            qa="error-subtitle"
          >
            {countryTrans['exception']}
          </ConTextAtom>

          <ConTextAtom
            fontFamily="regular"
            fontSizes="medium"
            fontWeight="bold"
            tag="h4"
            align="left"
            qa="error-text"
          >
            {countryTrans['exception.explanation']}
          </ConTextAtom>
        </div>
      </Section>
    </div>
  );
};
